import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAButtonSecondary, RAImage } from "@/components/customs";
import { Grid } from "antd";
import { PATH_PUBLIC_IMAGES } from "@/config/images";

const { useBreakpoint } = Grid;

export function ServiceAirFreightBackground({ banner = {}, onRequestAirFreight }) {
	const screens = useBreakpoint();

	return (
		<div style={{ width: "100%", position: "relative" }}>
			<WrapperSection>
				<RAImage
					url={
						screens.xs
							? banner?.mobile_banner
							: banner?.desktop_banner || PATH_PUBLIC_IMAGES.service_af_background
					}
					width="100%"
					height="100vh"
				/>
				<Overlay />
				<WrapperContent>
					<TextContainer className="animate__animated animate__fadeInUp animate__slow">
						<RATypography
							variant={screens?.md ? "h1" : "h2"}
							color="#fff"
							style={{ display: "inline" }}
							whiteSpace="pre-wrap"
						>
							{banner?.title || ""}
						</RATypography>
					</TextContainer>

					<WrapperQuote className="animate__animated animate__fadeInUp">
						<RAButtonSecondary
							data-testid="hero_requestAirFreightBtn"
							background="#fff"
							title={banner?.button_content?.toUpperCase() || "REQUEST"}
							onClick={() => onRequestAirFreight()}
							width="100%"
							border="none"
						/>
					</WrapperQuote>
				</WrapperContent>
			</WrapperSection>
		</div>
	);
}

const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	background: rgba(0, 0, 0, 0.3);
`;

const WrapperSection = styled.div`
	width: 100%;
`;
const TextContainer = styled.div`
	text-align: center;
	background: linear-gradient(180deg, #ffffff 39.72%, rgba(255, 255, 255, 0) 140.65%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
`;
const WrapperContent = styled.div`
	position: absolute;
	top: 25%;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
`;
const WrapperQuote = styled.div`
	padding-top: 30px;
	max-width: 280px;
	--animate-duration: 3s;
`;
